// extracted by mini-css-extract-plugin
export default {"container":"AddedAppliance_container__Ae3Xb","viewContainer":"AddedAppliance_viewContainer__Jxkk4","editContainer":"AddedAppliance_editContainer__Gwtts"};